import clsx from "clsx";

type Props = {
  id: string;
  register: any;
  fieldAddOn?: string;
  fieldAddOnClasses?: string;
  additionalClasses?: string;
  placeHolder?: string;
  getValues: any;
  setValue: any;
};

function SocialLink({
  fieldAddOn,
  id,
  additionalClasses,
  placeHolder,
  register,
  getValues,
  setValue,
  fieldAddOnClasses,
}: Props) {
  function removeHttpsFromFields() {
    setValue(id, getValues(id).replace(/^https?:\/\//, ""));
  }
  return (
    <div className="mt-1 flex rounded-ll border border-white  font-satoshi 2xl:mt-2">
      <span
        className={clsx(
          "items-center rounded-l-ll bg-primary p-3 leading-7 text-white 2xl:p-4",
          "text-xs font-medium",
          fieldAddOnClasses,
        )}
      >
        {fieldAddOn}
      </span>
      <input
        autoComplete="off"
        type="text"
        id={id}
        className={clsx(
          "block w-full flex-1 rounded-r-ll bg-primary p-3 text-white placeholder:opacity-70 2xl:p-4",
          "text-sm font-medium placeholder:text-white focus:border-white focus:ring-white",
          additionalClasses,
        )}
        placeholder={placeHolder}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...register(id, { onBlur: removeHttpsFromFields })}
      />
    </div>
  );
}
export default SocialLink;

SocialLink.defaultProps = {
  fieldAddOn: "https://",
  placeHolder: "Enter Website Link",
  additionalClasses: "",
};
